import { render, staticRenderFns } from "./UsersRequestsNotification.vue?vue&type=template&id=71a9e9f3&"
import script from "./UsersRequestsNotification.vue?vue&type=script&lang=js&"
export * from "./UsersRequestsNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports